module.exports = __webpack_public_path__ + "static/media/9S.50caac18.png";